import type { FaireProductEntity } from "../../entity_types/product";

export const p_9gowjx571u: FaireProductEntity = {
  token: "p_9gowjx571u",
  type: "product",
  name: "15 Min Pamper Me Kit \u2013 K-Beauty Self-Care/Home Spa Kit (7pc)",
  brandName: "Naisture",
  imageUrl:
    "https://cdn.faire.com/fastly/a8cf7c02af5d05d4fb15ea29dd0105ae54f33e1e831aad3d072ab36ddf993a3d.jpeg",
  priceDollars: 7.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/542cb475252731ed00ed8d393cc8b3e3954600bd8ecd3e908a0ce39322f3f251.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
